<template>
  <div>
    <divisoria-descricao
      :titulo="'Integrações'"
      :descricao="'Adicione e visualize os códigos de integração desta empresa em outros sistemas'"
    />
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="2">
            <b-form-group label="ID ERP Contábil">
              <b-form-input v-model="empresa.codigoIntegracao" />
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Integração">
              <b-form-select v-model="integracaoSelecionada">
                <option :value="null">
                  Selecione
                </option>
                <option value="omie">
                  Omie
                </option>
                <option value="gclick">
                  G-Click
                </option>
                <option value="acessorias">
                  Acessórias
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>

          <!-- Omie -->
          <b-col
            v-if="integracaoSelecionada === 'omie'"
            cols="4"
          >
            <b-form-group label="ID Omie">
              <b-form-input
                v-model="empresa.idOMIE"
                :disabled="true"
              />
              <span
                v-if="empresa.statusOmie === 2 || empresa.statusOmie === 4"
                class="text-success"
                style="font-size: 0.857rem;"
              >
                Integrada em: {{ converteData(empresa.dataIntegracaoOmie) }}
              </span>
              <span
                v-else-if="empresa.statusOmie === 3"
                class="text-danger"
                style="font-size: 0.857rem;"
              >
                Erro: {{ empresa.mensagemErroOmie }}
                Data: {{ converteData(empresa.dataErroOmie) }}
              </span>
              <span
                v-else-if="empresa.statusOmie === 1"
                class="text-danger"
                style="font-size: 0.857rem;"
              >
                Pendente: Aguardando CNPJ da empresa para iniciar a integração!
              </span>
            </b-form-group>
          </b-col>

          <b-col
            v-if="integracaoSelecionada === 'omie'"
            cols="3"
          >
            <div class="div-integracao-data">
              <div>
                <legend style="font-size: 14px;">
                  Data de Cadastro na Omie
                </legend>
              </div>
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  :title="mensagemAtencao"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <data-input
              v-model="dataInclusaoOmie"
              :disabled="true"
            />
          </b-col>

          <!-- G-Click -->
          <b-col
            v-if="integracaoSelecionada === 'gclick'"
            cols="4"
          >
            <b-form-group label="ID G-Click">
              <b-form-input
                v-model="empresa.idGClick"
                disabled
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="integracaoSelecionada === 'gclick'"
            cols="3"
          >
            <div class="div-integracao-data">
              <div>
                <legend style="font-size: 14px;">
                  Data de Cadastro na G-Click
                </legend>
              </div>
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  :title="mensagemAtencao"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <data-input
              v-model="dataInclusaoGClick"
              :disabled="true"
            />
          </b-col>

          <!-- Acessórias (somente front, sem integração ainda) -->
          <b-col
            v-if="integracaoSelecionada === 'acessorias'"
            cols="4"
          >
            <b-form-group label="ID Acessórias">
              <b-form-input
                v-model="idAcessorias"
                disabled
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="integracaoSelecionada === 'acessorias'"
            cols="3"
          >
            <div class="div-integracao-data">
              <div>
                <legend style="font-size: 14px;">
                  Data de Cadastro na Acessórias
                </legend>
              </div>
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  :title="mensagemAtencao"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <data-input
              v-model="dataInclusaoAcessorias"
              :disabled="true"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
.div-integracao-data {
  display: flex;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { mapGetters } from 'vuex'
import moment from 'moment'
import 'moment/locale/pt-br'
import { convertDateWithHour } from '@/@core/utils/utils'

export default {
  name: 'AbaIntegracao',
  components: {
    FontAwesomeIcon,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      mensagemAtencao:
        'Nesse campo é registrado a data de inclusão da empresa no sistema, ou a data de envio da integração, e essa data fica na coluna "Inclusão" do cadastro de clientes.',
      dataInclusaoOmie: null,
      dataInclusaoGClick: null,
      integracaoSelecionada: null,
      idAcessorias: null,
      dataInclusaoAcessorias: null,
    }
  },
  computed: {
    ...mapGetters('empresa', ['empresa']),
  },
  created() {
    if (this.empresa.statusOmie === 2 || this.empresa.statusOmie === 4) {
      this.dataInclusaoOmie = moment(this.empresa.dataInclusaoOmie).format('DD/MM/YYYY')
    }

    if (this.empresa.idGClick) {
      this.dataInclusaoGClick = moment(this.empresa.dataInclusaoGClick).format('DD/MM/YYYY')
    }

    // Seleção inicial da integração
    if (this.empresa.statusOmie === 2 || this.empresa.statusOmie === 4 || this.empresa.idOMIE) {
      this.integracaoSelecionada = 'omie'
    } else if (this.empresa.idGClick) {
      this.integracaoSelecionada = 'gclick'
    } else {
      this.integracaoSelecionada = null
    }
  },
  methods: {
    converteData(value) {
      return convertDateWithHour(value)
    },
  },
}
</script>
